// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/funnel
import React from "react";
import { useState, useEffect } from "react";
import { ResponsiveFunnel } from "@nivo/funnel";
import { CardContent, Card, CardHeader, Divider } from "@mui/material";
import { Box } from "@mui/system";



// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export default function Funnel({ data }) {

  

  const funnelData = [
    {
      id: "applications",
      value: data["applications"],
      label: "Total Applicants",
    },
    {
      id: "interviews",
      value: data["interviews"],
      label: "Total Interviews",
    },
    {
      id: "assessments",
      value: data["assessments"],
      label: "Assessments",
    },
    {
      id: "hires",
      value: data["hires"],
      label: "Total Hires",
    },
  ];


  return (
    <Card>
      <CardHeader title="Recruitment Funnel - Total" />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: "relative",
          }}
        >
          <ResponsiveFunnel
            data={funnelData}
            margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
            shapeBlending={0.08}
            spacing={3}
            colors={{ scheme: "accent" }}
            borderWidth={5}
            labelColor={{
              from: "color",
              modifiers: [["darker", 3]],
            }}
            currentBorderWidth={0}
            motionConfig="wobbly"
          />
        </Box>
      </CardContent>
    </Card>
  );
}
